const ReviewReducer = (state = {}, action) => {
    switch (action.type) {
        case 'DRIVER_REVIEWED':
            return {
                ...state,
                driverReviewed: action.payload
            }
        case 'ALL_DRIVERS_REVIEWED':
            return {
                ...state,
                allDriversReviewed: true
            }
        case 'VEHICLE_REVIEWED':
            return {
                ...state,
                vehicleReviewed: action.payload
            }
        case 'ALL_VEHICLES_REVIEWED':
            return {
                ...state,
                allVehiclesReviewed: true
            }
        case 'HISTORY_REVIEWED':
            return {
                ...state,
                historyReviewed: action.payload
            }
        case 'DATA_REVIEW_COMPLETED':
            return {
                ...state,
                dataReviewCompleted: true
            }
        case 'POPULATE_CUSTOMER_ACTIVITY':
            return {
                ...state,
                reviewData: action.payload
            }
        case 'REMOVE_DRIVER':
            console.log(state);
            return {
                ...state,
                reviewData: {
                    ...state.reviewData,
                    subjects: action.payload
                    ///subjects: action.payload
                }
            }
        case 'REMOVE_VEHICLE':
            console.log(state);
            return {
                ...state,
                reviewData: {
                    ...state.reviewData,
                    vehicles: action.payload
                    ///subjects: action.payload
                }
            }
        default:
            return {
                ...state
            }
    }
}

export default ReviewReducer;


// WEBPACK FOOTER //
// ./src/Review/reducers.js